export default __webpack_public_path__ + "static/media/time.1e5c1fde.svg";